import { toast } from '@hooks/use-toast';
import { screenLink } from '@lib/livePolls/liveLinks';
import { logger } from '@utils/logger';
import { copyToClipboard } from '@utils/clipboard';
import { ShareEntityType, shareContent } from '@utils/shareHelpers';

// AIDEV-NOTE: the screen link is the author's own (it carries the presenter key): copied or shared only from
// the host view, the host controls and the author's card, never logged.

/** "Copy screen link": the clipboard and today's "Link copied!" toast (TECH-867 § Views H). */
export const copyScreenLink = async (code: string, key: string): Promise<void> => {
  try {
    await copyToClipboard(screenLink(code, key));
    toast({ title: 'Link copied!' });
  } catch (error) {
    logger.error('Failed to copy the screen link', error instanceof Error ? error.name : 'unknown');
    toast({
      title: 'Copy failed',
      description: 'Unable to copy link. Please try again or copy the URL manually.',
      variant: 'error',
    });
  }
};

/** "Share screen link": the native share sheet, else the web share, else the clipboard (today's path). */
export const shareScreenLink = async (
  code: string,
  key: string,
  title: string | null,
): Promise<void> => {
  try {
    await shareContent(title ?? '', screenLink(code, key), ShareEntityType.Question);
  } catch (error) {
    logger.warn('Sharing the screen link failed', error instanceof Error ? error.name : 'unknown');
  }
};
